<template>
  <div>
    <PageHeader :title="update ? 'ویرایش فرصت شغلی' : 'اضافه کردن فرصت شغلی'" :items="pageHeaderItems" />
    <Loader v-if="loading" />
    <b-row v-else>
      <div class="card">
        <Section title="اطلاعات شغل">
          <div class="my-3">
            <BaseText
              :maxlength="2000"
              v-model="model.advertisingCode"
              title="کدآگهی"
              placeholder="کدآگهی"
              :required="true"
              :showError="submit && !model.advertisingCode"
              errortext="وارد کردن کد آگهی اجباری است"
            />
          </div>
          <div class="my-3">
            <BaseText
              :maxlength="2000"
              v-model="model.jobTitle"
              title="عنوان شغل"
              placeholder="عنوان شغل"
              :required="true"
              :showError="submit && !model.jobTitle"
              errortext="وارد کردن عنوان شغل اجباری است"
            />
          </div>
          <div class="my-3">
            <DateTimeOffset
              :value="model.publishDate"
              @input="model.publishDate = $event"
              title="تاریخ انتشار شغل"
              placeholder="تاریخ انتشار"
              :hasDefaultDate="false"
              :required="true"
              :error="submit && !model.publishDate"
              errorText="وارد کردن تاریخ شغل اجباری است"
            />
          </div>
        </Section>

        <Section title="اطلاعات سازمان">
          <div class="my-3">
            <BaseText :maxlength="2000" v-model="model.organizationName" title="نام سازمان" placeholder="نام سازمان" />
          </div>
          <div class="my-3">
            <BaseText :maxlength="2000" v-model="model.city" title="شهر" placeholder="شهر" />
          </div>
          <div class="my-3">
            <BaseText :maxlength="2000" v-model="model.neighbourhood" title="محله" placeholder="محله" />
          </div>
          <div class="my-3">
            <BaseText :maxlength="2000" v-model="model.industryOrganiazation" title="صنعت سازمان" placeholder="صنعت سازمان" />
          </div>
          <div class="my-3">
            <BaseText :maxlength="2000" v-model="model.organiazationActivityDescription" title="توصیف سازمان" placeholder="توصیف سازمان" />
          </div>
        </Section>

        <Section title="شرایط همکاری">
          <div class="my-3">
            <ComboBox
              :searchedData="cooperationTypes"
              title="نوع همکاری"
              placeholder="نوع همکاری"
              :selectedValue="selectedCooperation"
              @select="fillSelectedCooperation"
              :required="true"
              :showError="submit && (model.cooperationType === null || model.cooperationType === '')"
              errortext="وارد کردن نوع همکاری اجباری است"
            />
          </div>
          <div class="my-3">
            <ComboBox :searchedData="attendTypes" title="نحوه ی حضور" placeholder="دور کاری / حضوری" :selectedValue="selectedAttend" @select="fillSelectedAttend" />
          </div>
          <div class="my-3">
            <BaseText :maxlength="2000" v-model="model.workExperience" title="سابقه" placeholder="سابقه" />
          </div>
          <div class="my-3">
            <BaseText :maxlength="2000" v-model="model.salary" title="حقوق دریافتی" placeholder="حقوق دریافتی" />
          </div>
          <div class="my-3">
            <EditorInput
              textAreaClass="align-items-center"
              :value="model.jobDescription"
              @input="model.jobDescription = $event"
              title="شرح شغل و وظایف"
              placeholder="شرح شغل و وظایف"
              rows="4"
            />
          </div>
        </Section>

        <Section title="ارسال رزومه">
          <div class="my-3">
            <BaseText :maxlength="2000" v-model="model.jobLink" title="لینک شود به" placeholder="لینک شود به" />
          </div>
        </Section>

        <Section title="نمایش شغل">
          <div>
            <b-form-checkbox v-model="disable" class="pt-2">
              <div class="mx-1">غیرفعال</div>
            </b-form-checkbox>
          </div>
        </Section>
      </div>
    </b-row>
    <div class="card p-3 d-flex flex-row justify-content-end">
      <b-button @click="$router.push('/list/advertisings')">انصراف</b-button>
      <b-button variant="primary ms-2 px-5" @click="addJob">ثبت</b-button>
    </div>
    <Toast :title="message" :error="error" :showToast="message !== ''" />
  </div>
</template>
<script>
import BaseText from '../../common/form/formModules/BaseText.vue'
import ComboBox from '../../common/form/formModules/ComboBox.vue'
import DateTimeOffset from '../../common/form/formModules/DateTimeOffset.vue'
import Section from '../../common/form/Section.vue'
import Loader from '../../common/loader.vue'
import Toast from '../../common/Toast.vue'
import PageHeader from '../../layoutComponents/page-header.vue'
import EditorInput from '../../common/form/formModules/editorInput.vue'
import dadbananAdvertisingProvider from '../../../services/dadban/advertising'

export default {
  name: 'add-advertising',
  components: { PageHeader, Loader, Toast, Section, BaseText, DateTimeOffset, ComboBox, EditorInput },
  props: {
    update: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      message: '',
      error: false,
      showToast: false,
      model: {
        advertisingCode: '',
        jobTitle: '',
        publishDate: '',
        organizationName: '',
        city: '',
        neighbourhood: '',
        cooperationType: '',
        remote: true,
        salary: '',
        jobDescription: '',
        workExperience: '',
        industryOrganiazation: '',
        organiazationActivityDescription: '',
        jobLink: '',
        isEnable: true,
      },
      disable: false,
      loading: false,
      selectedCooperation: '',
      selectedAttend: '',
      cooperationTypes: [
        { key: 0, value: 'تمام وقت' },
        { key: 1, value: 'پاره وقت' },
        { key: 2, value: 'پروژه ای' },
      ],
      attendTypes: [
        { key: 0, value: 'دور کاری' },
        { key: 1, value: 'حضوری' },
      ],
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت فرصت شغلی', active: true },
      ],
      submit: false,
    }
  },
  watch: {
    'model.publishDate'(c) {
      if (c && !c.includes('T')) {
        this.model.publishDate = this.model.publishDate.replaceAll('/', '-') + 'T00:00:00.000Z'
      }
    },
    disable(c) {
      this.model.isEnable = !c
    },
  },
  mounted() {
    if (this.update) {
      this.fetchJob()
    }
  },
  methods: {
    async fetchJob() {
      try {
        this.loading = true
        const req = await dadbananAdvertisingProvider.getById(+this.$route.params.id)
        req.data.data.jobDescription = req.data.data.jobDescription.replace(/\n/g, '')
        this.model = req.data.data

        if (this.model.isEnable === false) {
          this.disable = true
        }
        this.cooperationTypes.filter((item) => {
          if (item.key === this.model.cooperationType) {
            this.selectedCooperation = item.value
          }
        })
        if (this.model.remote) {
          this.selectedAttend = this.attendTypes[0].value
        } else this.selectedAttend = this.attendTypes[1].value
        this.loading = false
        console.log(JSON.stringify(this.model.jobDescription))
      } catch (error) {
        this.loading = false
      }
    },
    async addJob() {
      this.model.remote = this.model.remote === 0 ? true : false
      this.model.advertisingCode = +this.model.advertisingCode
      this.submit = true
      if (!this.model.advertisingCode || !this.model.jobTitle || !this.model.publishDate || this.model.cooperationType === null || this.model.cooperationType === '') {
        window.scrollTo(0, 0)
        return
      }

      try {
        this.loading = true
        if (this.update) {
          const req = await dadbananAdvertisingProvider.updateAdvertising(this.model)
          if (req.status === 200) {
            this.message = 'اطلاعات با موفقیت ثبت شد.'
          } else {
            this.error = true
            this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
          }
          this.loading = false
          return false
        }
        const req = await dadbananAdvertisingProvider.addAdvertising(this.model)
        if (req.status === 200) {
          this.$router.push('/list/advertisings/detail/' + req.data.data)
        } else {
          this.error = true
          this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        }
        this.loading = false
      } catch (error) {
        this.error = true
        this.message = error.response.data.message
        this.loading = false
      }
    },
    fillSelectedCooperation(e) {
      if (!e) {
        this.model.cooperationType = null
        return false
      }
      this.model.cooperationType = this.cooperationTypes.find((item) => item.value === e).key
    },
    fillSelectedAttend(e) {
      if (!e) {
        delete this.model.remote
        return false
      }
      this.model.remote = this.attendTypes.find((item) => item.value === e).key
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .quillWrapper {
  max-width: 100% !important;
}
::v-deep .ql-editor {
  text-align: right;
  direction: rtl;
}
</style>
